<script>
import store from '@state/store'
export default {
  components: {},
  props: {
    companyId: { type: [String, Number], required: false, default: null },
    groupId: { type: [String, Number], required: false, default: null },
  },
  data() {
    return {
      errorFlag: false,
      adminEmail: '',
    }
  },
  watch: {},
  methods: {
    addEventAdmins() {
      const params = {
        eventAdmin: this.adminEmail,
      }
      store
        .dispatch('adminUsers/addEventAdminToGroup', {
          groupId: this.groupId,
          params,
        })
        .then((response) => {
          this.$emit('refresh-event-admins-table')
          alert('Event admins group have been successfully invited!')
        })
        .catch((err) => alert(err.message || 'Something went wrong.'))
    },
  },
}
</script>

<template>
  <div class="pt-16 w-2/3 mx-auto">
    <div>
      <h3 class="text-2xl text-blue-darker mb-1">Add Event Admin</h3>
    </div>
    <div class="flex  mb-3">
      <div class="w-1/2 pr-12">
        <BaseInputText v-model="adminEmail" placeholder="Email" />
      </div>
    </div>
    <div v-if="errorFlag" class="mb-3 text-sm errors text-volunteer_red">
      Please fill in the user email.
    </div>
    <button
      class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
      @click="addEventAdmins"
    >
      Add Event Admin
    </button>
  </div>
</template>
